import _compact from 'lodash/compact';
import resolve from '../../../modules/api/resolve';
import {
  apiGet, apiPost, generateFormData,
} from '../../../modules/apiHelper';
import { toBoolean } from '../../../modules/dataHelper';

async function addParticipant(data) {
  const formData = generateFormData(data);

  const response = await apiPost('add_prt', formData, 62).catch((err) => {
    console.error('error adding participants::', err);
    return false;
  }).then((res) => {
    if (!res) return false;
    if (toBoolean(res.data.error)) return false;

    return true;
  });

  return response;
}

async function removeParticipant(data) {
  const formData = generateFormData(data);

  const response = await apiPost('del_prt', formData, 64).catch((err) => {
    console.error('error removing participant', err);
    return false;
  }).then((res) => {
    if (!res) return false;
    if (toBoolean(res.data.error)) return false;

    return true;
  });

  return response;
}

async function addExpertParticipant(data) {
  const formData = generateFormData(data);

  const response = await apiPost('add_exprt_prt', formData, 77).catch((err) => {
    console.error('error adding expert participants::', err);
    return false;
  }).then((res) => {
    if (!res) return false;
    if (toBoolean(res.data.error)) return false;

    return true;
  });

  return response;
}

async function removeExpertParticipant(data) {
  const formData = generateFormData(data);

  const response = await apiPost('del_prt', formData, 77).catch((err) => {
    console.error('error removing expert participant', err);
    return false;
  }).then((res) => {
    if (!res) return false;
    if (toBoolean(res.data.error)) return false;

    return true;
  });

  return response;
}

export default {
  async getProgramParticipants(context, data) {
    const formData = generateFormData({
      meetingid: data.id,
      companyid: data.companyId,
    });

    const result = await resolve(apiPost('company_participants', formData, 63)).then(async (res) => {
      if (!res) return false;

      /** @type {Array} */
      const participants = res.company_participants || [];

      // get users' data
      const promises = [];

      // cache data first
      await Promise.allSettled([
        apiGet('gender', 5),
        apiGet('countries', 5),
        apiGet('county', 5),
        apiGet('profession', 5),
        apiGet('experience', 5),
        apiGet('availability', 5),
        apiGet('group_goals', 5),
        context.dispatch('companyRegions', data.companyId),
      ]);

      participants.forEach((participant) => {
        if (toBoolean(participant.expt)) return;
        const prom = context.dispatch('getUserData', participant.userid);

        promises.push(prom);
      });

      const users = await Promise.all(promises);
      // console.log('participants::', users);

      return users;
    });

    return result;
  },
  async saveProgramParticipants(context, { meetingId, companyId, participants }) {
    // get current participants
    /** @type {Array} */
    const currentParticipants = await context.dispatch('getProgramParticipants', {
      id: meetingId,
      companyId,
    });

    // console.log(currentParticipants, participants);

    participants.forEach((participant) => {
      const foundInCurrent = currentParticipants.find((part) => Number(part.id) === Number(participant));

      // if already exist, skip
      if (foundInCurrent) return;

      // new, so add
      addParticipant({
        meetingid: meetingId,
        userid: participant,
      });
    });

    currentParticipants.forEach((currentParticipant) => {
      const foundInNew = participants.find((part) => Number(part) === Number(currentParticipant.id));

      // if found in new list, skip
      if (foundInNew) return;

      // if not exist in new list, remove
      removeParticipant({
        meetingid: meetingId,
        userid: currentParticipant.id,
      });
    });
  },
  async saveParticipantsInProgram(context, {
    meetingId, programId, companyId, userType,
  }) {
    const usersInProgram = await context.dispatch('getProgramUsers', {
      companyId,
      progid: programId,
    }, { root: true });
    //
    const filteredUsers = userType === 0
      ? usersInProgram
      : usersInProgram.filter((user) => Number(user.type) === Number(userType));
    //
    const usersIds = filteredUsers.map((user) => user.id);

    await context.dispatch('saveProgramParticipants', {
      meetingId,
      companyId,
      participants: _compact(usersIds),
    });
  },
  async saveExpertsProgramParticipants(context, {
    meetingId, companyId, programId, participants,
  }) {
    // get current participants
    /** @type {Array} */
    const currentParticipants = await context.dispatch('getExpertsProgramParticipants', {
      id: meetingId,
      companyId,
      programId,
    });

    // console.log(currentParticipants, participants);

    participants.forEach((participant) => {
      const foundInCurrent = currentParticipants.find((part) => Number(part.id) === Number(participant));

      // if already exist, skip
      if (foundInCurrent) return;

      // new, so add
      addExpertParticipant({
        meetingid: meetingId,
        expertid: participant,
      });
    });

    currentParticipants.forEach((currentParticipant) => {
      const foundInNew = participants.find((part) => Number(part) === Number(currentParticipant.id));

      // if found in new list, skip
      if (foundInNew) return;

      // if not exist in new list, remove
      removeExpertParticipant({
        meetingid: meetingId,
        expertid: currentParticipant.id,
      });
    });
  },
  async getExpertsProgramParticipants(context, data) {
    const formData = generateFormData({
      meetingid: data.id,
      companyid: data.companyId,
    });

    const result = await resolve(apiPost('expert_participants', formData, 77)).then(async (res) => {
      if (!res) return false;

      /** @type {Array} */
      const participants = res.expert_participants || [];

      // get users' data
      const promises = [];

      participants.forEach((participant) => {
        const prom = context.dispatch('getExpert', participant.userid);

        promises.push(prom);
      });

      const users = await Promise.all(promises);

      return users;
    });

    return result;
  },
};
